<template>


    <!--        <a href="#" v-on:click="goBack" class="mr-2" style="color: maroon;">←</a>-->

    <div v-if="this.work">
        <div class="work-title">
            {{work.title}}
        </div>
        <b-row>
            <b-col cols="12">

                <!--                <img style="width: 100%;" :src="apiURL+this.work.coverimage.url" alt="">-->

                <zoom-on-hover class="cover-image" v-if="this.work.zoom" :scale="1.5" :img-normal="apiURL+this.work.coverimage.url"></zoom-on-hover>
                <img class="cover-image" v-else :src="apiURL+this.work.coverimage.url" alt="">
                <!--                TODO zoom on hover is optional. selectable in CMS-->
            </b-col>
            <b-col cols="12">
                <p class="work-description">{{work.description}}</p>
            </b-col>
        </b-row>
        <VueShowdown class="work-content pt-2" :markdown="this.work.content"></VueShowdown>
    </div>


</template>

<script>
    import _ from 'lodash'

    export default {
        name: "WorkPage",
        mounted() {
        },
        computed: {
            work: function () {
                if (this.$store.state.works) {
                    return _.find(this.$store.state.works, {"title": this.$route.params.workTitle})

                } else {
                    return null
                }
            },
            apiURL: function () {
                return process.env.VUE_APP_API_URL
            }
        },
        methods: {
            goBack: function () {
                parent.history.go(-1);
            }
        }
    }
</script>

<style scoped lang="scss">
    .work-description {
        font-style: oblique;
    }

    .work-content {
        img {
            max-width: 100%;
        }
    }

    .cover-image {
        width: 100%;

    }

    .work-title {
        margin-bottom: 2em;
        font-weight: bold;
    }
</style>

<style lang="scss">


    .work-content {
        img {
            max-width: 100%;
        }
    }
</style>